import { State } from '../reducers/rootReducer'
import TechnicalData from '../../entities/TechnicalData'

const technicalDataSelector = (state: State): TechnicalData => state.technicalData

export default technicalDataSelector
